<template>
  <div id="app">
    <section class="hero is-dark is-small is-bold">
      <div class="hero-body">
        <div class="container is-fluid">
          <h1 class="title">
            Thelemic Tools
          </h1>
        </div>
      </div>
    </section>

    <div class="container is-fluid">
      <router-view/>
    </div>
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style lang="sass">
input[readonly],
textarea[readonly]
  background-color: #eee

.section
  padding-bottom: 1.5rem
  padding-top: 1.5rem
</style>



// WEBPACK FOOTER //
// src/App.vue